import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import converterMoeda from '~js/converter-moeda';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaVisualizar(pesquisa) {

  pesquisa.itens.map(item => {
    item.quantidade = converterMoeda.paraReal(item.quantidade || 0);

    item.pesquisas.map(pesquisa => {
      pesquisa.valorUnitarioPesquisa = converterMoeda.paraReal(pesquisa.valorUnitarioPesquisa || 0);
      pesquisa.valorTotalPesquisa = converterMoeda.paraReal(pesquisa.valorTotalPesquisa || 0);
      pesquisa.valorFrete = converterMoeda.paraReal(pesquisa.valorFrete || 0);
    });
  });

  return pesquisa;
}

async function normalizarParaSalvar(solicitacao) {
  var pesquisas = [];

  for (var i = 0; i < solicitacao.itens.length; i++) {    

    for (var j = 0; j < solicitacao.itens[i].pesquisas.length; j++) {

      if ((solicitacao.itens[i].pesquisas[j].pesquisaValidada == 'true') || (solicitacao.itens[i].pesquisas[j].pesquisaValidada == true)) {
        solicitacao.itens[i].pesquisas[j].pesquisaValidada = true;
      } else {
        solicitacao.itens[i].pesquisas[j].pesquisaValidada = false;
      }
      
      var pesquisa = {
        IDItemCompra: solicitacao.itens[i].pesquisas[j].idItemCompra,
        IDPesquisa: solicitacao.itens[i].pesquisas[j].idPesquisa,
        PesquisaValidada: solicitacao.itens[i].pesquisas[j].pesquisaValidada,
        NomeFornecedor: '',
        DocumentoFornecedor: '',
        ValorUnitarioPesquisa: 0,
        ValorTotalPesquisa: 0,
        idSolicitacaoCompra: solicitacao.idSolicitacaoCompra,
      }

      pesquisas.push(pesquisa);
    }
  }

  return pesquisas;
}


export default {
  lista: (filtros) => {
    const parametros = Object.assign({}, filtros);

    return Vue.http.get('/api/pesquisapreco', { params: parametros }).then(response => response.data);
  },
  obterPorIdRelatorio: id => {
    return Vue.http.get(`/api/pesquisapreco/${id}`)
      .then(response => response.data)
      .then(pesquisa => normalizarParaVisualizar(pesquisa));
  },
  aprovar: async(solicitacao) => {
    var pesquisas = await normalizarParaSalvar(solicitacao);

    return Vue.http.post('/api/pesquisapreco/aprovar', pesquisas).then(res => res.data.id);
  },
  arquivos: id => {
    return Vue.http.get(`/api/pesquisapreco/solicitacaocoordenador/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/pesquisapreco/solicitacaocoordenador/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/aprovar-pesquisa-preco/servico.js